import { observer } from "@legendapp/state/react";
import { useNavigate } from "react-router-dom";
import { pageState$, state$ } from "../../../state";
import { ReactComponent as ArrowLeftIcon } from "./../../../assets/icons/arrow-left.svg";
import { ReactComponent as ErrorIcon } from "./../../../assets/icons/error.svg";
import "./PageError.scss";


const PageError = observer(() => {


    const isFullWidthState = state$.settings.isFullWidthState.get();
    const navigate = useNavigate();

    return (
        <div className={`content clause-type-error animated-max-width ${isFullWidthState ? 'container-fluid' : 'container'}`}>
            <div className="row">
                <div className="col">
                    <div className="content__wrapper">
                        <h3 className="error__header">
                            <span className="error__icon">
                                <ErrorIcon />
                            </span>

                            Error 500 - Internal Server Error
                        </h3>

                        <p className="error__content">
                            Oooops, looks like something went wrong with our servers, <br /> if this problem persists, please contact an administrator.
                        </p>

                        <div className="error__actions">
                            <button type="button" className="error__action btn btn--mute" onClick={() => {
                                pageState$.errorMessage.set(undefined);
                                pageState$.activeItem.data.set(undefined);
                                pageState$.activeItem.title.set(undefined);
                                navigate('/');
                            }}>
                                <span className="error__action-icon">
                                    <ArrowLeftIcon />
                                </span>

                                Back Home
                            </button>

                            <button type="button"
                                className="error__action btn btn--default btn--long"
                                onClick={() => window.location.replace(window.location.origin)}>
                                Restart Application
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
})

export default PageError;
